export default {
  fields: {
    code: 'Kode',
    tag: 'Tag',
    type: 'Type',
    discount_type: 'Rabattype',
    discount: 'Rabat',
    usage_threshold: 'Brugsgrænse',
    quantity: 'Antal',
    expires_at: 'Udløber',
    customers: 'Kunder',
    purchases: 'Ordrer',
    sales: 'Salg',
    level: 'Niveau',
    max_discount: 'Maks. rabat',
  },
  tags: {
    master: 'Master',
    campaign: 'Kampagne',
    one_time: 'Engangs',
  },
  types: {
    single_use: 'Enkeltbrug',
    multi_use: 'Flergangsbrug',
    unknown: 'Ukendt',
  },
  discount_types: {
    fixed_amount: 'Fast beløb',
    percentage: 'Procent',
    unknown: 'Ukendt',
  },
  labels: {
    discount: 'Rabat',
    usage_threshold: 'Brugsgrænse',
    company: 'Virksomhed',
  },
  collecting_emails: {
    description:
      'Her kan du konfigurere den engangs-kampagnekode, der genereres til nye brugere, når de tilmelder sig på hjemmesiden.',
  },
  buttons: {
    edit: 'Rediger',
  },
  toasts: {
    successfully_deleted: 'Indstillinger for kampagnekode blev slettet',
    failed_to_load_data: 'Data kunne ikke indlæses',
  },
};
